import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FaBars, FaHome, FaSignOutAlt, FaSignInAlt, FaTimes, FaShieldAlt } from 'react-icons/fa';
import logo from '../assets/mirai_innovation_logo.jpeg';
import { PLATFORM_NAME_SHORT } from '../constants/platform';
import '../styles/Navbar.css'; // <- usa este css

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const isAuthenticated = !!localStorage.getItem('token');

  const handleLogout = () => {
    localStorage.removeItem('token');
    setUser(null);
    setIsMenuOpen(false);
    navigate('/login');
  };

  const toggleMobileMenu = () => setIsMenuOpen(prev => !prev);
  const closeMobileMenu = () => setIsMenuOpen(false);

  // Obtener información del usuario al cargar el componente
  useEffect(() => {
    const fetchUserInfo = async () => {
      if (isAuthenticated) {
        try {
          // axios interceptor añade Authorization automáticamente
          const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/auth/me`);
          setUser(response.data);
        } catch (error) {
          console.error('Error obteniendo información del usuario:', error);
        }
      }
    };

    fetchUserInfo();
  }, [isAuthenticated]);

  return (
    <nav className="mi-navbar fixed-top" role="navigation" aria-label="Main navigation">
      <div className="mi-nav-inner container-fluid">
        {/* Izquierda: logo + brand */}
        <div className="brand-wrap">
          <div className="logo-wrap" aria-hidden="true">
            <img src={logo} alt="Logo" className="logo-img" />
          </div>
          <span className="brand-name d-none d-sm-inline">{PLATFORM_NAME_SHORT}</span>
        </div>

        {/* Menú de navegación - Centro (solo desktop) */}
        <div className="navbar-nav d-none d-lg-flex">
          <Link to="/dashboard" className="nav-link">
            <FaHome /> <span>Inicio</span>
          </Link>
        </div>

        {/* Derecha: acciones (desktop) + hamburguesa (mobile) */}
        <div className="actions">
          {/* Boton menu movil (unico) */}
          <button
            className="hamburger d-lg-none"
            onClick={toggleMobileMenu}
            aria-label={isMenuOpen ? 'Cerrar menu' : 'Abrir menu'}
            aria-expanded={isMenuOpen}
            aria-controls="mobile-drawer"
          >
            {isMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
          </button>

          {/* Auth desktop */}
          <div className="auth-cta d-none d-lg-flex">
            {isAuthenticated ? (
              <button onClick={handleLogout} className="btn-primary-cta">
                <FaSignOutAlt /><span>Cerrar Sesion</span>
              </button>
            ) : (
              <Link to="/login" className="btn-primary-cta">
                <FaSignInAlt /><span>Iniciar Sesion</span>
              </Link>
            )}
          </div>
        </div>
      </div>

      {/* Drawer movil */}
      <aside
        id="mobile-drawer"
        className={`mobile-drawer ${isMenuOpen ? 'show' : ''}`}
        aria-hidden={!isMenuOpen}
      >
        <div className="drawer-header">
          <h5>Menu</h5>
          <button className="icon-btn" onClick={closeMobileMenu} aria-label="Cerrar menu">
            <FaTimes size={20} />
          </button>
        </div>

        <div className="drawer-items" role="menu">
          <div className="mobile-menu-items">
            <Link
              to="/dashboard"
              className="mobile-menu-item"
              onClick={closeMobileMenu}
            >
              <FaHome /> <span>Inicio</span>
            </Link>
            {/* Botón de admin en móvil si el usuario tiene ese rol */}
            {isAuthenticated && user?.role === 'admin' && (
              <Link
                to="/admin-dashboard"
                className="mobile-menu-item"
                onClick={closeMobileMenu}
              >
                <FaShieldAlt /> <span>Panel Admin</span>
              </Link>
            )}
            {isAuthenticated ? (
              <button
                onClick={handleLogout}
                className="mobile-menu-item mobile-menu-button"
              >
                <FaSignOutAlt /> <span>Cerrar Sesión</span>
              </button>
            ) : (
              <Link
                to="/login"
                className="mobile-menu-item mobile-menu-button"
                onClick={closeMobileMenu}
              >
                <FaSignInAlt /> <span>Iniciar Sesión</span>
              </Link>
            )}
          </div>
        </div>
      </aside>

      {/* Overlay */}
      <button
        className={`mobile-overlay ${isMenuOpen ? 'show' : ''}`}
        onClick={closeMobileMenu}
        aria-hidden={!isMenuOpen}
        aria-label="Cerrar menu"
      />
    </nav>
  );
};

export default Navbar;
